import React from "react";
import { StyleSheet, Text } from "react-native";
import { Button as _Button } from "src/common/assets/mixins";
import { TextProps } from "@rneui/base";

const CustomText = ({ children, style, ...props }: TextProps) => {
  return (
    <Text {...props} style={[styles.text, style]}>
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  text: {
    fontFamily: "Montserrat",
    color: "white",
    fontSize: 16,
  },
});

export default CustomText;
